import * as React from 'react'

import type { PopoverItemType } from 'types/ui'

import { useMenu } from 'components/ds'
import Tooltip from 'components/ui/tooltip'

type Props = {
  options: PopoverItemType[]
  onOptionClick: (value: PopoverItemType['value']) => void
}

/**
 * The folder/channel menu items, shared by the three-dot menu and the row's
 * right-click menu so the two can never drift apart.
 */
const GroupMenuBody = ({ options, onOptionClick }: Props): React.ReactNode => {
  const Menu = useMenu()

  return (
    <>
      {options.map(option => (
        <Tooltip key={option.value} content={option.tooltip ?? null}>
          <Menu.Item
            disabled={option.disabled}
            color={option.destructive ? 'red' : undefined}
            onSelect={() => onOptionClick(option.value)}
          >
            {option.label}
          </Menu.Item>
        </Tooltip>
      ))}
    </>
  )
}

export default GroupMenuBody
